import { AbstractJavascriptFunctionCallFactory } from "./AbstractJavascriptFunctionCallFactory";
import { AbstractJavascriptFunctionCallVO } from "./AbstractJavascriptFunctionCallVO";
import { JavascriptCallOnLoginCompleteVO } from "./JavascriptCallOnLoginCompleteVO";
/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 04.10.12, 09:44
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import { EnvGlobalsHandler } from "../../../EnvGlobalsHandler";
import { BasicModel } from "../../../model/BasicModel";

export class JavascriptCallOnLoginCompleteFactory implements AbstractJavascriptFunctionCallFactory {
    public createVO(): AbstractJavascriptFunctionCallVO {
        let vo: JavascriptCallOnLoginCompleteVO = new JavascriptCallOnLoginCompleteVO(EnvGlobalsHandler.globals.accountId, BasicModel.userData.playerID, BasicModel.instanceProxy.selectedInstanceVO.instanceId, EnvGlobalsHandler.globals.networkId, EnvGlobalsHandler.globals.gameId);

        return vo;
    }
}

